import { MediaLimitsIndicationView } from '@app/modules/social-export/lib/format-media-limits-indication';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

type MediaLimitsIconProps = {
  kind: MediaLimitsIndicationView['kind'];
};

/**
 * Icon for a media-limits indication kind (blocked / downscale / display tip).
 */
export function MediaLimitsIcon({ kind }: MediaLimitsIconProps) {
  switch (kind) {
    case 'blocked':
      return <ErrorOutlineRoundedIcon fontSize="small" color="error" />;
    case 'needs_transcoding':
      return <WarningAmberRoundedIcon fontSize="small" color="warning" />;
    case 'platform_displays_lower':
      return <InfoOutlinedIcon fontSize="small" color="info" />;
    default:
      return null;
  }
}
